import request from '@/utils/request'

const END_POINT = '/graphservice/api/v1/graphs'
const api = {
  getPerformance (stocks) {
    return request.post(END_POINT, stocks)
  }
}

export default api
